module.exports = __webpack_public_path__ + "static/media/twitter.8850ce7a.png";